import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { slide } from '../../animations';

@Component({
  selector: 'resource-form-modal',
  templateUrl: './resource-form-modal.component.html',
  styleUrls: ['./resource-form-modal.component.scss'],
  animations: [
    slide
  ]
})
export class ResourceFormModalComponent implements OnInit {
  @Input()  selectedResource: any;
  @Output() onHideFormModal = new EventEmitter<boolean>();

  resource = {
    title: "",
    description: "",
    creator: "",
    fileKey: "",
    fileSize: 0,
    type: 0
  };

  resourceType;

  uploadedFile: File;

  constructor(
    private dbService: DBService,
    private csService: CloudStorageService
  ) { }

  ngOnInit() {
    if (this.selectedResource) {
      this.resource = this.selectedResource;
      this.resourceType = this.resource.type;
    }
  }

  onHideModal() {
    this.onHideFormModal.emit(true);
  }

  submitForm() {


    if (this.uploadedFile) {
      this.resource.fileKey = this.uploadedFile.name;
      this.resource.fileSize = this.uploadedFile.size;
    }

    this.resource.type = parseInt(this.resourceType);

    if (this.selectedResource) {
      this.dbService.updateResource(this.selectedResource.$key,
                                    this.resource, this.uploadedFile);
    } else {
      this.resource.creator = "MPG Admin";
      this.dbService.addResource(this.resource, this.uploadedFile);
    }


    this.onHideModal();
  }

  /* Display file preview */
  onFileChange(event) {
    let file = event.target.files[0];
    this.uploadedFile = file;
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/resource-form-modal/resource-form-modal.component.ts